import React, { useState } from 'react';
import { Phone, Check } from 'lucide-react';
export function Contact() {
  const [showCopied, setShowCopied] = useState(false);
  const handlePhoneClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) {
      e.preventDefault();
      const phoneNumber = '(818) 381-9905';
      navigator.clipboard.writeText(phoneNumber).then(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
      }).catch(() => {
        window.location.href = 'tel:8183819905';
      });
    }
  };
  return <section className="w-full bg-gradient-to-b from-black to-zinc-950 py-20 px-4" id="contact" data-id="element-26">
      <div className="max-w-5xl mx-auto text-center" data-id="element-27">
        <h2 className="text-3xl md:text-5xl font-black uppercase text-white mb-2" data-id="element-28">
          Ready for a{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-600" data-id="element-29">
            Showroom Shine?
          </span>
        </h2>
        <p className="text-gray-400 text-lg mb-8" data-id="element-30">
          Serving Los Angeles, Ventura County, Agoura Hills, Thousand Oaks,
          Calabasas & more
        </p>

        <div className="flex flex-col items-center gap-8" data-id="element-31">
          <a href="tel:8183819905" onClick={handlePhoneClick} className="group relative flex flex-col items-center justify-center p-8 md:p-12 bg-zinc-900 border-2 border-red-600 rounded-2xl hover:bg-zinc-800 transition-all duration-300 shadow-[0_0_40px_-10px_rgba(220,38,38,0.3)] hover:shadow-[0_0_60px_-10px_rgba(220,38,38,0.5)] cursor-pointer" aria-label="Call Mike's Pro Detail" data-id="element-32">
            <span className="text-xl md:text-2xl text-gray-400 uppercase tracking-widest mb-2 font-bold" data-id="element-33">
              Call or Text Mike
            </span>
            <div className="flex items-center gap-3 md:gap-6" data-id="element-34">
              <Phone className="w-8 h-8 md:w-12 md:h-12 text-red-500 fill-red-500/20" data-id="element-35" />
              <span className="text-4xl md:text-6xl lg:text-7xl font-black text-white tracking-tighter group-hover:scale-105 transition-transform" data-id="element-36">
                (818) 381-9905
              </span>
            </div>
            <div className="absolute -bottom-4 bg-black px-4 py-1 border border-zinc-800 rounded-full" data-id="element-37">
              <span className="text-green-500 font-bold uppercase text-sm flex items-center gap-2" data-id="element-38">
                <span className="relative flex h-3 w-3" data-id="element-39">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-40"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500" data-id="element-41"></span>
                </span>
                Available Now
              </span>
            </div>
          </a>

          {/* Copied to clipboard toast */}
          {showCopied && <div className="fixed top-8 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-3 bg-green-600 text-white rounded-lg shadow-lg animate-in fade-in slide-in-from-top-2 duration-300" data-id="element-42">
              <Check className="w-5 h-5" data-id="element-43" />
              <span className="font-semibold" data-id="element-44">
                Phone number copied to clipboard!
              </span>
            </div>}

          <div className="mt-12 pt-8 border-t border-zinc-900 w-full flex flex-col md:flex-row justify-between items-center text-gray-600 text-sm" data-id="element-45">
            <p data-id="element-46">
              © {new Date().getFullYear()} Mike's Pro Detail. All rights
              reserved.
            </p>
            <p className="mt-2 md:mt-0" data-id="element-47">Mobile Detailing Services</p>
          </div>
        </div>
      </div>
    </section>;
}